export const MESSAGE_TYPE_ID = '@type';
export const UNLOADED_MESSAGE = 'UNLOADED_MESSAGE';